(function () {
    "use strict";

    angular.module("app").component("habilCheckmark", {
        bindings: { checked: "=", },
        template: `<span class="fa" ng-class="{'fa-times': !$ctrl.checked, 'fa-check': $ctrl.checked}"></span>`
    });
})();